import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};

export const getFieldVisibleityState = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/getfieldvisibleitystate/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const insertPersonalPageAnswer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/insertPersonalPageAnswer/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const insertHistory = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/inserthistory/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const deleteHistory = async (newData, controller) => {
  try {
    console.log(newData, controller)
    let url = config.apiserver + "/page/deletehistory/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const calculatePageItemsFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/calculatePageItems/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getBackPageFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/gobackpage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getHelpPageFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/gethelppage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getResultPageFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/getresultpage/";

    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getNextPageFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/nextpage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const insertCopyList = async (newData, controller) => {
  try {
    let url = config.apiserver + "/page/insertCopyList/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
